var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Video(el) {
	var t = this;
	t.$el = $(el);
	t.$videoInner = t.$el.find('.js-video-inner');
	t.$video = t.$el.find('.js-video-modal-video iframe');
	t.$modal = t.$el.find('.js-video-modal');
	t.$iconClose = t.$el.find('.js-video-modal-close');
	t.$overlayClose = t.$el.find('.js-video-modal-overlay');

	t.$videoInner.on('click', function () {
		t.openModal();
	});

	t.$iconClose.on('click', function () {
		t.closeModal();
	});

	t.$overlayClose.on('click', function () {
		t.closeModal();
	});
}


Video.prototype.openModal = function () {
	var t = this;
	t.$modal.addClass('video-modal--active');
};

Video.prototype.closeModal = function () {
	var t = this;
	t.$modal.removeClass('video-modal--active');
	t.$video.attr('src', t.$video.attr('src'));
};

module.exports = Video;
